<template>
  <v-dialog v-model="dialog" class="px-0" max-width="800px">
    <template v-slot:activator="{ on }">
      <span v-if="messages" class="link" v-on="on">Ver variações</span>
    </template>
    <v-card>
      <v-card-title><span class="title-preview mb-3">Variações de mensagens de saída</span></v-card-title>
      <v-card-subtitle
        ><p class="subtitle mb-0">
          As variações de mensagens de descadastro são selecionadas aleatoriamente durante o envio para melhorar a estabilidade dos disparos.
        </p></v-card-subtitle
      >
      <v-card-text>
        <div style="max-height: 300px; overflow-y: auto">
          <v-data-table :headers="headers" :items="items" hide-default-header disable-pagination hide-default-footer max-height="200px" />
        </div>
        <mf-action-buttons
          class="mt-4"
          :primary-button="{
            text: 'Fechar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Mensagem',
          value: 'message',
          sortable: false,
          align: 'left',
        },
      ]
    },
    items() {
      return this.messages.map((text) => ({
        message: text,
      }))
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false
    },
  },
}
</script>
